// import { observable } from "mobx";
import React from 'react';
// tslint:disable-next-line: no-submodule-imports
import { FaTrash } from 'react-icons/fa';

import { DbKey } from '../../../../adl-gen/common/db';
import { ApplicationRole, AppUser, AppUserStatus } from '../../../../adl-gen/totalinteraction/futurefit/db';
import { AppUserListEntry } from '../../../../adl-gen/totalinteraction/futurefit/frontend';
import { UserData } from '../../../../adl-gen/totalinteraction/futurefit/requests';
import { EditIcon } from '../../../../ui/common/icons';
import { Button } from '../../../../ui/widgets/button/button';
import { SelectOption } from '../../../../ui/widgets/select/select';
import {
  // displayCheckItem,
  MultiSelectContainer,
  DisplayText
} from '../../common/editor';

const styles = require('../../common/details-view.css');
const buttonStyles = require('../../common/common.css');

interface AppUserDetailsViewProps {
  user: AppUserListEntry;
  userData: UserData;
  onUpdate(appUserId: DbKey<AppUser>): Promise<void>;
  role: 'client-admin' | 'super';
  /// Fullname of the user this AppUser reports to (AppUser.managerId), if any
  managerFullname?: string;
}

export class AppUserDetailsView extends React.Component<AppUserDetailsViewProps> {
  /// TODO: Sort this out later
  private readonly deleteAllowed: boolean = false;

  displayStatus = () => {
    const { user } = this.props;
    return user.status === AppUserStatus.active
      ? 'active'
      : user.status === AppUserStatus.suspended
      ? 'suspended'
      : 'deleted';
  };

  displayRole = () => {
    const { user } = this.props;
    return user.role === ApplicationRole.admin
      ? 'admin'
      : user.role === ApplicationRole.user
      ? 'user'
      : /// Should never happen for client admin
        'super';
  };

  displayGroupOptions = (idList: string[]) => {
    const { userData } = this.props;
    // Groups: Get select options for all groups, pluck out ones
    // user is member of, sort by name
    const groups = userData.groupList
      .map(g => ({ label: g.value.name, value: g.id }))
      .reduce((acc: SelectOption[], next: SelectOption) => {
        if (idList.includes(next.value as string)) {
          acc.push(next);
        }
        return acc;
      }, [])
      .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), 'en', { sensitivity: 'base' }));
    if (groups.length === 0) {
      return [{ label: 'None', value: '' }];
    } else {
      return groups;
    }
  };

  displayUserQuizOptions = (completed: boolean) => {
    const { user, userData } = this.props;
    // Quiz: Get select options for all, pluck out where user
    // has completed or pending, get a unique list and sort by name
    const quizzes = userData.quizList
      .map(q => ({ label: q.value.title.value.en, value: q.id }))
      .reduce((acc: SelectOption[], next: SelectOption) => {
        if (
          user.quizzes
            .filter(q => (completed ? q.value.completedAt !== null : q.value.completedAt === null))
            .map(q => q.value.quizId)
            .includes(next.value as string)
        ) {
          acc.push(next);
        }
        return acc;
      }, [])
      .filter((q, idx, arr) => q.value === arr[idx].value)
      .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase(), 'en', { sensitivity: 'base' }));
    if (quizzes.length === 0) {
      return [{ label: 'None', value: '' }];
    } else {
      return quizzes;
    }
  };

  FullName = DisplayText({
    field: this.props.user.fullname,
    title: 'Full Name',
    xsSpan: 2
  });
  Email = DisplayText({
    field: this.props.user.email,
    title: 'Email',
    xsSpan: 2
  });
  Status = DisplayText({
    field: this.displayStatus(),
    title: 'Active/Suspended',
    xsSpan: 2
  });
  ApplicationRole = DisplayText({
    field: this.displayRole(),
    title: 'User Type',
    xsSpan: 2
  });
  // Seat = displayCheckItem({
  //   field: this.props.user.seat,
  //   label: "Seat",
  //   xsSpan: 2
  // });

  MemberOf = MultiSelectContainer({
    options: this.displayGroupOptions(this.props.user.memberOf.map(g => g.value.userGroupId)),
    selectedOptions: this.displayGroupOptions(this.props.user.memberOf.map(g => g.value.userGroupId)),
    title: 'Team Membership',
    xsSpan: 4
  });

  ManagerOf = MultiSelectContainer({
    options: this.displayGroupOptions(this.props.user.managerOf.map(g => g.value.userGroupId)),
    selectedOptions: this.displayGroupOptions(this.props.user.managerOf.map(g => g.value.userGroupId)),
    title: 'Manager Of',
    xsSpan: 4
  });

  /// Evaluated at render time (not a class field) so it picks up the manager name
  /// when the user list finishes loading after this view has mounted
  renderUsersManager = () =>
    DisplayText({
      field: this.props.managerFullname || 'None',
      title: "User's Manager",
      xsSpan: 2
    });

  CompletedAssessments = MultiSelectContainer({
    options: this.displayUserQuizOptions(true),
    selectedOptions: this.displayUserQuizOptions(true),
    title: 'Completed Assessments',
    xsSpan: 4
  });

  PendingAssessments = MultiSelectContainer({
    options: this.displayUserQuizOptions(false),
    selectedOptions: this.displayUserQuizOptions(false),
    title: 'Pending Assessments',
    xsSpan: 4
  });

  renderTopButtons = () => {
    const updateButton = () => {
      return (
        <div className={buttonStyles.buttonList}>
          <Button
            // onClick={async () => this.start("update")}
            onClick={async () => this.props.onUpdate(this.props.user.id)}
            Icon={EditIcon}
            size="small"
            variant="round"
            // disabled={this.editable() === undefined}
          >
            Update
          </Button>
        </div>
      );
    };

    const deleteButton = () => {
      return (
        <div className={buttonStyles.buttonList}>
          <Button
            // onClick={async () => this.start("delete")}
            Icon={FaTrash}
            size="small"
            variant="round"
            // disabled={this.selected.size === 0}
          >
            Delete
          </Button>
        </div>
      );
    };

    return (
      <div className={buttonStyles.buttonListContainer}>
        {this.deleteAllowed && deleteButton()}
        {updateButton()}
      </div>
    );
  };

  renderDetails = () => (
    <div className={styles.page}>
      <div className={styles.body}>
        <div>{this.renderTopButtons()}</div>
        <div className={styles.row}>
          {this.FullName}
          {this.Email}
        </div>
        <div className={styles.row}>
          {this.Status}
          {this.ApplicationRole}
          {this.renderUsersManager()}
          {/* {this.Seat} */}
        </div>
        <div className={styles.row}>
          {this.MemberOf}
          {this.ManagerOf}
          {this.CompletedAssessments}
          {this.PendingAssessments}
        </div>
      </div>
    </div>
  );

  render() {
    return <React.Fragment>{this.renderDetails()}</React.Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/admin/ui/components/detail-views/appuser-details-view.tsx